import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, delay, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ROOT_ENV } from '../../../../../services/config/config.service';
import { NotificationService } from '../../../../../common/services';
import { NewsletterSubscribe, NewsletterSubscribeConfirmation } from './newsletter-subscription.actions';
import { NewsletterSubscriptionService } from './newsletter-subscription.service';
import { Error, CustomHttpErrorResponse, REDIRECTION_BASIC_DELAY } from '../../../../../common';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface NewsletterSubscriptionStateModel {
  loaded: boolean;
}

const initialState: NewsletterSubscriptionStateModel = {
  loaded: false,
};

@State<NewsletterSubscriptionStateModel>({
  name: 'newsletterSubscribe',
  defaults: initialState,
})
@Injectable()
export class NewsletterSubscriptionState {
  @Selector()
  static getState(state: NewsletterSubscriptionStateModel): NewsletterSubscriptionStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: NewsletterSubscriptionStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private newsletterService: NewsletterSubscriptionService,
    private notificationService: NotificationService,
  ) {}

  @Action(NewsletterSubscribeConfirmation)
  confirmNewsletterSubscription(
    ctx: StateContext<NewsletterSubscriptionStateModel>,
    { payload }: NewsletterSubscribeConfirmation,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.newsletterService.confirmNewsletterSubscription(payload).pipe(
      map(() => {
        ctx.patchState({ loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => {
        return of(this.notificationService.error(error.message)).pipe(
          delay(REDIRECTION_BASIC_DELAY),
          tap(() => window.open(ROOT_ENV, '_self')),
        );
      }),
    );
  }

  @Action(NewsletterSubscribe)
  newsletterSubscribe(
    ctx: StateContext<NewsletterSubscriptionStateModel>,
    { payload }: NewsletterSubscribe,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.newsletterService.newsletterSubscribe(payload).pipe(
      catchError(({ error }: CustomHttpErrorResponse<Error>) => {
        return of(this.notificationService.error(error.message));
      }),
    );
  }
}
